export default __webpack_public_path__ + "static/media/aandacht_erbij.f627b7b8.jpg";